import $ from 'jquery';

const initWrap = function(el) {

	var label = $('<label>').appendTo(el);
	var ul = $('<ul>').addClass('options').appendTo(el);
	var select = el.find('select');
	var placeholder = select.data('placeholder');
    var parent = ul;


	select.find('*').each(function() {

        if(this.tagName == "OPTGROUP") {
            parent = $("<ul>").addClass('group').appendTo(ul);
            $("<label>").html($(this).attr('label')).appendTo(parent);
        } else {
            var o = $(this);
    		var l = o.data('label') || o.text();
    		var li = $('<li>').text(l).data('val',o.attr('value')).appendTo(parent);
    		if(o.prop('disabled')) {
    			li.addClass('disabled');
    		} else {
    			li.on('click',function(e) {
    				select.val( $(this).data('val') ).trigger('change');
                    el.removeClass('active');
                    e.stopPropagation();
    			});
    		}
        }

	});

	select.on('click',function(event) {
		event.preventDefault();
	});

	el.on('click',function(event) {
		if($(event.target).is(select)) {
			return;
		}
		el.toggleClass('active');
	});

	var setLabel = function() {
		var i = select.get(0).selectedIndex;
		var o = select.find('option').eq(i);
		var l;
		if(o.attr('value') == '' && placeholder) {
			l = placeholder;
		} else {
			l = o.data('label') || o.text();
		}
		label.html( l );
		ul.find('li').removeClass('selected').eq(i).addClass('selected');
	}

	select.on('change update',setLabel);
	setLabel();

	// var t = setInterval(function() {
	// 	var p = el.css('position');
	// 	if(p!="static") {
	// 		clearInterval(t);
	// 		el.css('minWidth',ul.outerWidth());
	// 	}
	// },50);

}

const initBodyClick = function() {
	$('body').on('click',function(event) {
		var wrap = $(event.target).closest('.select-wrap');
		$('.select-wrap.active').each(function() {
			var w = $(this);
			if(!w.is(wrap)) {
				w.removeClass('active');
			}
		});

	});
}

export default {

	init: function(el) {
        if(!el) {
            el = $('body');
            initBodyClick();
        }
		$('.select-wrap').each( function() {
			initWrap( $(this) );
		} );
        $('select[data-wrap]').each(function() {
            $(this).wrap('<span class="select-wrap"></span>');
            var w = $(this).data('wrap');
            if(w) {
                $(this).parent().attr('data-wrap',w);
            }
            initWrap( $(this).parent() );
        });
	}

}
